import { useEffect, useRef, useState } from 'react';

/**
 * Renders HTML email inside an iframe and resizes to match document height.
 */
export function BrandedPreviewIframe({ html, title = 'Email Preview' }) {
  const ref = useRef(null);
  const [height, setHeight] = useState(600);

  useEffect(() => {
    const iframe = ref.current;
    if (!iframe) return;

    const measure = () => {
      try {
        const doc = iframe.contentDocument;
        if (!doc) return;
        const next = Math.max(
          doc.documentElement.scrollHeight,
          doc.body?.scrollHeight || 0,
        );
        if (next && next !== height) setHeight(next);
      } catch {
        // sandbox/origin oddities — ignore
      }
    };

    iframe.addEventListener('load', measure);
    const t1 = setTimeout(measure, 250);
    const t2 = setTimeout(measure, 1000);

    return () => {
      iframe.removeEventListener('load', measure);
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [html, height]);

  return (
    <div className="border rounded-md overflow-hidden bg-[#f4f4f5]">
      <iframe
        ref={ref}
        title={title}
        srcDoc={html}
        className="w-full border-0 block"
        style={{ height: `${height}px` }}
        sandbox="allow-same-origin allow-popups"
      />
    </div>
  );
}
